
import { Swiper, Controller, Navigation } from 'swiper'

Swiper.use([Controller, Navigation])

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    slideClasses: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      carousel: null
    }
  },
  watch: {
    'options.controller.control': {
      handler (v) {
        if (!this.carousel) {
          return
        }

        this.carousel.controller.control = v
      }
    }
  },
  mounted () {
    this.carousel = new Swiper(this.$refs.carousel, {
      ...this.options,
      on: {
        init: carousel => this.$emit('init', carousel),
        slideChange: carousel => this.$emit('slide-change', carousel)
      },
      resizeObserver: true,
      slidesPerView: 'auto'
    })
  }
}
